import { computed, defineComponent, ref } from "vue"
import { Field } from "vant"

export default defineComponent({
  name: "FormItem",
  props: {
    title: String,
    rules: Object,
    name: String,
    config: Object,
    required: { type: Boolean }
  },
  setup(props, { slots, expose }) {
    const fieldProps = computed(() => {
      return {
        label: props.title,
        rules: props.rules,
        name: props.name,
        required: props.required,
        ...props.config
      }
    })

    const fieldSlots = {
      ...slots,
      input: slots.default || (() => <div></div>)
    }

    const fieldRef = ref(null)
    expose({ inst: fieldRef })

    return () => (
      <Field ref={fieldRef} {...fieldProps.value} vSlots={fieldSlots}></Field>
    )
  }
})
